// extracted by mini-css-extract-plugin
export default {"recommend":"index_recommend_Ow8bL","title":"index_title_qTMLL","list_box":"index_list_box_fKZap","more":"index_more_5BZPX"};